import { useState } from 'react';
import { notify } from '@/components';
import {
  UpdateTaskGroupArgs,
  useGetTaskGroupQuery,
  useUpdateTaskGroupMutation,
} from '@/redux';
import { EditTaskGroupModal } from './EditTaskGroupModal';

export function useEditTaskGroupAction() {
  const [groupId, setGroupId] = useState<string>();
  const [update] = useUpdateTaskGroupMutation();
  const { data } = useGetTaskGroupQuery({ id: groupId! }, { skip: !groupId });

  const reset = () => {
    setGroupId(undefined);
  };

  const handleSubmit = (value: UpdateTaskGroupArgs) => {
    update(value)
      .unwrap()
      .then(() => {
        notify.success.t('tasks.groups.saved');
        reset();
      });
  };

  return {
    openEditGroup: (groupId: string) => {
      setGroupId(groupId);
    },
    editTaskGroupModal: (
      <>
        {groupId && data && (
          <EditTaskGroupModal
            onSubmit={handleSubmit}
            onClose={reset}
            value={data}
            id={groupId}
          />
        )}
      </>
    ),
  };
}
